import { APP_LINK, EVENTS as E, POLICY_LINK, TERMS_LINK } from '../constants';
import { useEventNameConstructor } from './useEventNameConstructor';
import { useSendEvents } from './useSendEvents';

export interface CheckoutLink {
  url: string;
  event?: string;
  label?: string;
}

export const CHECKOUT_LINKS: Record<string, CheckoutLink> = {
  terms: { event: E.TERMS_TAP, url: TERMS_LINK },
  'terms-of-use': { event: E.TERMS_TAP, url: TERMS_LINK, label: 'terms' },
  privacy: { event: E.POLICY_TAP, url: POLICY_LINK },
  refund_policy: { event: E.TERMS_TAP, url: `${TERMS_LINK}/#refund-policy`, label: 'refund' },
  subscription_policy: {
    event: E.TERMS_TAP,
    url: `${TERMS_LINK}/#auto-renewal-policy`,
    label: 'subscription_policy',
  },
  'help-email': { url: 'mailto:help@family-locator.com', label: 'help_email' },
  'fl-link': { url: APP_LINK, label: 'site' },
};

export const useCheckoutLinks = (screenId: string, links = CHECKOUT_LINKS) => {
  const sendEvents = useSendEvents({ screenId });
  const getEventName = useEventNameConstructor({ screenId });

  return (type: string) => {
    if (!type) return;
    const link = links[type];
    sendEvents(getEventName(E.CLICK), { [E.LR]: link?.label || type });
    if (link?.event) sendEvents(link.event);
    if (link?.url) window.open(link.url);
  };
};
